import moment from "moment";
import { EnrollmentCase } from "views/rent-reporting-id/types";
import { Label } from "views/rent-reporting/components/SelectPayment";

export const formatPropertyName = (enrollmentCase?: EnrollmentCase): string => {
  return enrollmentCase?.property?.name || "-";
};

export const formatAddress = (enrollmentCase?: EnrollmentCase): string => {
  if (!enrollmentCase?.address) return "-";
  const { address1, address2, city, state_or_province } =
    enrollmentCase.address;
  const parts = [address1];
  if (address2) parts.push(address2);
  parts.push(city, state_or_province);
  return parts.join(", ");
};

export const buildDelinquencyOptions = (
  delinquencyOptions?: Array<{ name: string; months_delinquency: number }>
) => {
  if (!delinquencyOptions?.length) return [];

  return delinquencyOptions.map((option) => ({
    value: option.months_delinquency,
    label: (
      <Label
        title={option.name}
        icon={
          <div className="bg-danger-50 h-5 w-5 flex items-center justify-center">
            <p className="text-danger-500 text-sm font-bold">
              {option.months_delinquency}
            </p>
          </div>
        }
      />
    )
  }));
};

export const getTabDisplayName = (enrollmentCase: EnrollmentCase): string => {
  if (enrollmentCase.property?.name) return enrollmentCase.property.name;
  if (enrollmentCase.address)
    return `${enrollmentCase.address.address1}, ${enrollmentCase.address.city}`;
  return `Enrollment ${enrollmentCase.id}`;
};

export const formatDate = (
  date?: string | null,
  format = "MMM D, YYYY",
  returnValue = "-"
): string => {
  if (!date) return returnValue;
  const dateMoment = moment(date);
  return dateMoment.isValid() ? dateMoment.format(format) : returnValue;
};
